import React, { useState, useEffect, useRef, useCallback } from 'react';
import $ from 'jquery';
import moment from 'moment';
import Hls from 'hls.js';
import MultiSelect from 'react-select';
import Form from 'react-validation/build/form';
import { faEdit, faBullhorn } from '@fortawesome/fontawesome-free-solid';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';
import { GoogleLogin } from 'react-google-login';
import fbIcon from '../../../../images/socialIcons/facebook.png';
import yotubeIcon from '../../../../images/socialIcons/youtubeicon.jpg';
import twitterIcon from '../../../../images/socialIcons/twitter.png';
import twitchIcon from '../../../../images/socialIcons/twitch.png';
import rocketIcon from '../../../../images/socialIcons/rocket.png';
import instagramIcon from '../../../../images/socialIcons/Instagram.png';
import calendarIcon from '../../../../images/socialIcons/calender.png';
import './DashboardDefault.css';

const MAX_ACTIVE = 3;
const FB_CLIENT_ID     = '231425867421205';
const GOOGLE_CLIENT_ID = '242384257630-cutoeuml04eq6e80t2rpg83leu0vpm97.apps.googleusercontent.com';

let hlsInstance;

// ─── Channel Card ─────────────────────────────────────────────────────────────
function ChannelCard({ dest, title, isWebcam, isScreen, onToggle, onEdit, onSchedule, onRadioChange }) {
  const platformIcon = () => {
    if (!dest.platformType) return dest.profilePic ? dest.profilePic : fbIcon;
    if (dest.platformType === 'Twitter')   return twitterIcon;
    if (dest.platformType === 'Twitch')    return twitchIcon;
    if (dest.platformType === 'Instagram') return instagramIcon;
    if (dest.platformType === 'Facebook')  return fbIcon;
    if (dest.type === 'YOUTUBE')           return dest.profilePic || yotubeIcon;
    return rocketIcon;
  };

  const avatarLetter = (dest.name || dest.email || 'R').charAt(0).toUpperCase();

  const statusEl = () => {
    if (dest.isLoading) {
      return (
        <span className="rs-channel-status connecting">
          <span className="rs-spinner" />
          {dest.isLoading}
        </span>
      );
    }
    if (dest.sessionStatus) return <span className="rs-channel-status online">● Online</span>;
    return <span className="rs-channel-status">● Offline</span>;
  };

  const displayName = dest.type === 'CUSTOM'
    ? `${dest.name} – Custom`
    : dest.type === 'YOUTUBE'
    ? `${dest.name} – YouTube`
    : dest.type === 'INSTAGRAM'
    ? (dest.name || dest.email)
    : `${dest.name} – Facebook ${dest.type || 'Page'}`;

  const isInsta = dest.platformType === 'Instagram' || dest.type === 'INSTAGRAM';

  return (
    <div className="rs-channel">
      {/* Main row — always same height */}
      <div className="rs-channel-header">
        <div className="rs-drag-handle">
          <span /><span /><span />
        </div>

        <div className="rs-channel-info">
          <div className="rs-channel-avatar">
            {dest.profilePic
              ? <img src={platformIcon()} alt={avatarLetter} />
              : avatarLetter}
          </div>
          <div>
            <div className="rs-channel-name">{displayName}</div>
            <div className="rs-channel-title">{title}</div>
            {statusEl()}
          </div>
        </div>

        <div className="rs-channel-actions">
          {!isWebcam && !isScreen && (
            <button className="rs-edit-btn" title="Agendar" onClick={() => onSchedule(dest)}>
              <img src={calendarIcon} alt="schedule" style={{ width: 18 }} />
            </button>
          )}
          {dest.platformType === 'Instagram' && (
            <button className="rs-edit-btn" title="Editar" onClick={() => onEdit(dest)}>
              <FontAwesomeIcon icon={faEdit} />
            </button>
          )}
          <label className="rs-switch">
            <input
              type="checkbox"
              checked={!!dest.sessionStatus}
              onChange={() => onToggle(dest)}
            />
            <span className="rs-slider" />
          </label>
        </div>
      </div>

      {/* Instagram orientation — second row, only when needed */}
      {isInsta && (
        <div className="rs-insta-radio" onChange={e => onRadioChange(dest, e)}>
          <label><input type="radio" value="normal"   defaultChecked={dest.broadcastType === 'normal'}   name={dest.id || dest.instagramId} /> Normal</label>
          <label><input type="radio" value="paisagem" defaultChecked={dest.broadcastType === 'paisagem'} name={dest.id || dest.instagramId} /> Paisagem</label>
          <label><input type="radio" value="square"   defaultChecked={dest.broadcastType === 'square'}   name={dest.id || dest.instagramId} /> Square</label>
        </div>
      )}
    </div>
  );
}

// ─── DashboardDefault ─────────────────────────────────────────────────────────
export default function DashboardDefault({ history, notifySuccess, notifyError }) {
  const [pages, setPages]               = useState([]);
  const [loaded, setLoaded]             = useState(false);
  const [isOnline, setIsOnline]         = useState(false);
  const [isWebcam, setIsWebcam]         = useState(false);
  const [isRtmp, setIsRtmp]             = useState(true);
  const [isScreen, setIsScreen]         = useState(false);
  const [streamSource, setStreamSource] = useState(false);
  const [totalConnections, setTotalConns] = useState(0);
  const [alertMessages, setAlertMessages] = useState([]);

  // Title modal
  const [showTitleModal, setShowTitleModal] = useState(false);
  const [title, setTitle]                   = useState('');
  const [description, setDesc]              = useState('');
  const [selectedRes, setSelectedRes]       = useState('1080p');
  const titleFormRef = useRef();

  // Schedule modal
  const [schedModal, setSchedModal]         = useState(false);
  const [schedItem, setSchedItem]           = useState({});
  const [schedType, setSchedType]           = useState('uma vez apenas');
  const [startTime, setStartTime]           = useState('');
  const [endTime, setEndTime]               = useState('');
  const [startDate, setStartDate]           = useState(moment().format('YYYY/MM/DD'));
  const [selectedDays, setSelectedDays]     = useState([]);
  const [selectedDates, setSelectedDates]   = useState([]);
  const schedFormRef = useRef();

  // Instagram modal
  const [instaModal, setInstaModal]         = useState(false);
  const [instaData, setInstaData]           = useState({});
  const [customKey, setCustomKey]           = useState('');
  const instaFormRef = useRef();

  // OTP modal
  const [otpModal, setOtpModal]             = useState(false);
  const [otpValue, setOtpValue]             = useState('');
  const [otpBody, setOtpBody]               = useState({});

  // Add channel modal
  const [addModal, setAddModal]             = useState(false);
  const [socialSelect, setSocialSelect]     = useState('');
  const [customName, setCustomName]         = useState('');
  const [customRtmp, setCustomRtmp]         = useState('');
  const [customKeyAdd, setCustomKeyAdd]     = useState('');
  const [customSite, setCustomSite]         = useState('Youtube');
  const [customUser, setCustomUser]         = useState('');
  const [customPass, setCustomPass]         = useState('');
  const [broadcastType, setBroadcastType]   = useState('normal');

  const m3u8Ref = useRef('');
  const rtmpRef = useRef('');
  const statusIntervalRef = useRef(null);
  const bitrateIntervalRef = useRef(null);
  const setIntervalIdsRef = useRef([]);

  const RESOLUTIONS = ['2160p', '1440p', '1080p', '720p', '480p', '360p', '240p'];
  const SCHED_TYPES = ['uma vez apenas', 'Diariamente', 'Semanalmente', 'Mensalmente'];
  const WEEKLY = [
    { value: 'sunday', label: 'Domingo' }, { value: 'monday', label: 'Segunda-feira' },
    { value: 'tuesday', label: 'Terça-feira' }, { value: 'wednesday', label: 'Quarta-feira' },
    { value: 'thursday', label: 'Quinta-feira' }, { value: 'friday', label: 'Sexta-feira' },
    { value: 'saturday', label: 'Sábado' }
  ];
  const DATES = Array.from({ length: 31 }, (_, i) => ({ value: String(i + 1), label: String(i + 1) }));

  // ── Stream URL builder ─────────────────────────────────────────────────────
  const buildStreamUrls = useCallback(() => {
    const app = localStorage.getItem('wowzaAppName');
    const isProduction = window.location.hostname.includes("relaystream.io") || window.location.hostname.includes('localhost');
    const rtmp = isProduction
      ? `rtmp://saopaulo01.relaystream.io:1935/${app}`
      : `rtmp://localhost:1935/${app}`;
    const m3u8 = isProduction
      ? `https://5ad482a77183d.streamlock.net/${app}/${app}/playlist.m3u8`
      : `${window.location.protocol}//localhost:1935/${app}/${app}/playlist.m3u8`;
    rtmpRef.current = rtmp;
    m3u8Ref.current = m3u8;
    return { rtmp, m3u8 };
  }, []);

  // ── HLS player ────────────────────────────────────────────────────────────
  const playHlsVideo = useCallback((src) => {
    const video = document.querySelector('#localVideo');
    if (!video) return;
    video.controls = true;
    video.autoplay = true;
    hlsInstance = new Hls();
    if (!Hls.isSupported()) {
      video.src = src;
    } else {
      hlsInstance.loadSource(src);
      hlsInstance.attachMedia(video);
      window.hls = hlsInstance;
    }
    setStreamSource(true);
  }, []);

  // ── Stop webcam ───────────────────────────────────────────────────────────
  const stopWebCamera = () => {
    const video = document.querySelector('video');
    if (video && video.srcObject) {
      video.srcObject.getTracks().forEach(t => t.stop());
    }
    setIsWebcam(false); setIsScreen(false); setIsRtmp(true);
  };

  // ── Bitrate polling ───────────────────────────────────────────────────────
  // Use a ref so the setInterval callback always calls the latest version
  // (avoids stale closures for isWebcam / streamSource).
  const wowzaBitRateRef = useRef(null);
  wowzaBitRateRef.current = () => {
    $.ajax({
      url: '/api/v1/bitrate',
      method: 'GET',
      success(resp) {
        const data = (resp && resp.response) ? resp.response : resp || {};
        if (data.bytesInRate > 0) {
          setIsOnline(true);
          setTotalConns(data.totalConnections || 0);
          const { m3u8 } = buildStreamUrls();
          if (!isWebcam && !streamSource) playHlsVideo(m3u8);
        } else {
          const video = document.getElementById('localVideo');
          if (video) { video.removeAttribute('src'); video.controls = false; video.load(); }
          stopWebCamera();
          setIsOnline(false); setStreamSource(false);
        }
      },
      error() {}
    });
  };
  const wowzaBitRateAjax = () => wowzaBitRateRef.current();

  // ── Social media list ─────────────────────────────────────────────────────
  const getSocialMediaList = useCallback(() => {
    $.ajax({
      method: 'GET',
      url: '/api/v1/facebook/pages',
      success(success) {
        if(success.response) setPages(success.response || []);
        setLoaded(true);
        if (!statusIntervalRef.current) {
          statusIntervalRef.current = setInterval(() => {
            $.ajax({
              method: 'GET', url: '/api/v1/facebook/pages',
              success(r) {
                setPages(prev => prev.map(old => {
                  const upd = (r.response || []).find(n =>
                    (old.id && n.id && old.id === n.id) || (old._id && n._id && old._id === n._id));
                  if (upd) old.sessionStatus = upd.sessionStatus;
                  return { ...old };
                }));
              },
              error() {}
            });
          }, 15000);
        }
      },
      error() { setLoaded(true); }
    });
  }, []);

  const getAddedTitle = useCallback(() => {
    $.ajax({
      url: '/api/v1/update/title', method: 'GET',
      success(resp) {
        if (resp.response) {
          setTitle(resp.response.title || '');
          setDesc(resp.response.description || '');
          setSelectedRes(resp.response.resolution || '1080p');
        }
      },
      error() {}
    });
  }, []);

  const getAlerts = useCallback(() => {
    $.ajax({
      url: '/api/v1/notification/alert', method: 'GET',
      success(resp) { setAlertMessages(resp.response || []); },
      error() {}
    });
  }, []);

  useEffect(() => {
    buildStreamUrls();
    getSocialMediaList();
    getAddedTitle();
    getAlerts();
    bitrateIntervalRef.current = setInterval(wowzaBitRateAjax, 15000);
    wowzaBitRateAjax();
    return () => {
      clearInterval(statusIntervalRef.current);
      clearInterval(bitrateIntervalRef.current);
      setIntervalIdsRef.current.forEach(i => clearInterval(i.intervalId));
    };
  }, []);

  // ── Toggle single channel ─────────────────────────────────────────────────
  const handleToggle = (dest) => {
    if (!isOnline && !dest.sessionStatus) return;
    const stopStream = !!dest.sessionStatus;

    setPages(prev => prev.map(p => {
      if ((p.id && p.id === dest.id) || (p._id && p._id === dest._id))
        return { ...p, isLoading: stopStream ? 'Desconectando' : 'Conectando' };
      return p;
    }));
    let url;
    if (dest.type === 'YOUTUBE' || dest.type === 'CUSTOM') {
      url = stopStream ? '/api/v1/facebook/stop/broadcast'
        : dest.type === 'YOUTUBE' ? '/api/v1/start/youtube/broadcast' : '/api/v1/start/custom/broadcast';
    } else if (dest.type === 'INSTAGRAM') {
      url = stopStream ? '/api/v1/instagram/stop/broadcast' : '/api/v1/instagram/start/broadcast';
    } else {
      url = stopStream ? '/api/v1/facebook/stop/broadcast' : '/api/v1/facebook/start/broadcast';
    }

    const data = {
      title, description, name: dest.name,
      resolution: selectedRes,
      email: dest.email,
      customRtmp: dest.customRtmp, customStreamKey: dest.customStreamKey,
      id: dest._id ? dest._id : dest.id, platformType: dest.platformType,
      type: dest.type, startTime: new Date().toISOString(), isWebcam
    };
    if (dest.platformType && dest.platformType.toLowerCase() === 'instagram') {
      data.instagramId = dest.instagramId || dest._id || dest.id;
      data.m3u8Url = m3u8Ref.current;
      data.rotate = dest.broadcastType || 'normal';
    }

    $.ajax({
      url, method: 'POST',
      data: JSON.stringify(data),
      success(resp) {
        if (resp.response && resp.response.two_factor_identifier) {
          resp.response.id = dest._id;
          setOtpBody(resp.response);
          setOtpValue('');
          setOtpModal(true);
        } else {
          notifySuccess(resp.message);
          setTimeout(getSocialMediaList, 5000);
        }
        if(pages){
          setPages(prev => prev.map(p => {
            if ((p.id && dest.id && p.id === dest.id) || (p._id && dest._id && p._id === dest._id))
              return { ...p, isLoading: null };
            return p;
          }));
        }
       
      },
      error(err) {
        console.log("errr-->",err)
        if(pages){
          setPages(prev => prev.map(p => {
            if ((p.id && p.id === dest.id) || (p._id && p._id === dest._id))
              return { ...p, isLoading: null };
            return p;
          }));
        }
        if (err && err.responseJSON) notifyError(err.responseJSON.message);
      }
    });
  };

  // ── Toggle all ────────────────────────────────────────────────────────────
  const handleToggleAll = (activate) => {
    if (!isOnline) return;
    const data = { allPages: pages.map(p => p.type === 'YOUTUBE' ? { ...p, startTime: new Date().toISOString() } : p) };
    $.ajax({
      url: '/api/v1/updateAllStream', method: activate ? 'POST' : 'DELETE',
      data: JSON.stringify(data),
      success(res) { notifySuccess(res.message); setTimeout(getSocialMediaList, 1000); },
      error(err) { if (err.responseJSON) notifyError(err.responseJSON.message); }
    });
  };

  // ── Update title ──────────────────────────────────────────────────────────
  const handleUpdateTitle = (e) => {
    e.preventDefault();
    setShowTitleModal(false);
    $.ajax({
      url: '/api/v1/update/title', method: 'POST',
      data: JSON.stringify({ title, description, resolution: selectedRes }),
      success(resp) { getSocialMediaList(); notifySuccess(resp.message); },
      error(err) { if (err.responseJSON) notifyError(err.responseJSON.message); }
    });
  };

  // ── Schedule ──────────────────────────────────────────────────────────────
  const openSchedule = (dest) => {
    const hh = String(new Date().getHours()).padStart(2, '0');
    const mm = String(new Date().getMinutes()).padStart(2, '0');
    setSchedItem(dest);
    setStartTime(`${hh}:${mm}`);
    setEndTime(`${hh}:${mm}`);
    setSchedType(SCHED_TYPES[0]);
    setSelectedDays([]);
    setSelectedDates([]);
    setSchedModal(true);
  };

  const handleAddSchedule = (e) => {
    e.preventDefault();
    const base = {
      scheduleType: schedType,
      selectedDays: selectedDays.map(d => d.value),
      startDate, startTime, endTime,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      selectedDates: selectedDates.map(d => d.value),
      description, title, resolution: selectedRes
    };
    const data = (schedItem.type === 'YOUTUBE' || schedItem.type === 'CUSTOM' || schedItem.type === 'PERISCOPE')
      ? { ...base, customRtmp: schedItem.customRtmp, customStreamKey: schedItem.customStreamKey, id: schedItem._id, platformType: schedItem.platformType, name: schedItem.name, type: schedItem.type }
      : { ...base, privacy: schedItem.privacy, id: schedItem.id, access_token: schedItem.access_token, name: schedItem.name, type: 'FACEBOOK' };

    $.ajax({
      url: '/api/v1/schedule', method: 'POST', data: JSON.stringify(data),
      success(resp) { setSchedModal(false); notifySuccess(resp.message); },
      error(err) { if (err.responseJSON) notifyError(err.responseJSON.message); }
    });
  };

  // ── Instagram key edit ────────────────────────────────────────────────────
  const openInstaEdit = (dest) => {
    setInstaData(dest);
    setCustomKey(dest.customStreamKey || '');
    setInstaModal(true);
  };

  const handleInstaUpdate = (e) => {
    e.preventDefault();
    $.ajax({
      method: 'PUT', url: '/api/v1/social/media',
      data: JSON.stringify({ _id: instaData._id, customStreamKey: customKey }),
      success(res) { setInstaModal(false); notifySuccess(res.message); getSocialMediaList(); },
      error(err) { if (err.responseJSON) notifyError(err.responseJSON.message); }
    });
  };

  // ── Instagram OTP ─────────────────────────────────────────────────────────
  const handleOtpSubmit = (e) => {
    e.preventDefault();
    if (otpValue.length !== 6) return;
    const data = { ...otpBody, verifiedToken: otpValue, startBroadcast: true, title, description };
    setOtpModal(false);
    $.ajax({
      method: 'POST', url: '/api/v1/instagram/verification/otp', data: JSON.stringify(data),
      success(res) { notifySuccess(res.message); setTimeout(getSocialMediaList, 5000); },
      error(err) { setOtpModal(true); if (err.responseJSON) notifyError(err.responseJSON.message); }
    });
  };

  // ── Instagram orientation radio ───────────────────────────────────────────
  const handleRadioChange = (dest, e) => {
    $.ajax({
      url: `/api/v1/update/instagram?id=${dest.id}&type=${e.target.value}`,
      method: 'GET',
      success() { getSocialMediaList(); },
      error() {}
    });
  };

  // ── Copy to clipboard ─────────────────────────────────────────────────────
  const copyText = (text) => navigator.clipboard.writeText(text);

  // ── Add channel — social login handlers ───────────────────────────────────
  const handleAddFacebook = (response) => {
    if (!response.accessToken) return;
    $.ajax({
      method: 'GET',
      url: `https://graph.facebook.com/v20.0/me?fields=accounts&access_token=${response.accessToken}`,
      success(success) {
        const fbPages = (success.accounts ? success.accounts.data : []).map(p => ({
          access_token: p.access_token, id: p.id, name: p.name
        }));
        fbPages.push({ name: response.name, id: response.id, access_token: response.accessToken, type: 'Timeline' });
        $.ajax({
          method: 'POST', url: '/api/v1/social/media',
          data: JSON.stringify({ data: { email: response.email, name: response.name, type: 'FACEBOOK', fbPages, access_token: response.accessToken, timelineId: response.id } }),
          success(res) { notifySuccess(res.message); setAddModal(false); getSocialMediaList(); },
          error(err)   { if (err.responseJSON) notifyError(err.responseJSON.message); }
        });
      },
      error() {}
    });
  };

  const handleAddGoogle = (user) => {
    $.ajax({
      method: 'POST', url: '/api/v1/social/media',
      data: JSON.stringify({ type: 'YOUTUBE', code: user.code }),
      success(res) { notifySuccess(res.message); setAddModal(false); getSocialMediaList(); },
      error(err)   { if (err.responseJSON) notifyError(err.responseJSON.message); }
    });
  };

  const openInstagramLogin = () => {
    const w = 700, h = 500;
    const top  = window.top.outerHeight / 2 + window.top.screenY - h / 2;
    const left = window.top.outerWidth  / 2 + window.top.screenX - w / 2;
    const win  = window.open('/instagram/login', 'Instagram Login',
      `toolbar=no,location=no,width=${w},height=${h},top=${top},left=${left}`);
    if (win) win.onunload = () => getSocialMediaList();
    setAddModal(false);
  };

  const handleAddCustom = (e) => {
    e.preventDefault();
    if (!customName || !customRtmp || !customKeyAdd) { notifyError('Preencha todos os campos'); return; }
    const data = { type: 'CUSTOM', customRtmp, customStreamKey: customKeyAdd, name: customName, platformType: customSite, custom_username: customUser, custom_password: customPass };
    if (customSite === 'Instagram') data.broadcastType = broadcastType;
    setAddModal(false);
    $.ajax({
      method: 'POST', url: '/api/v1/social/media', data: JSON.stringify(data),
      success(res) { notifySuccess(res.message); getSocialMediaList(); },
      error(err)   { if (err.responseJSON) notifyError(err.responseJSON.message); }
    });
  };

  const activeCount = pages.filter(p => p.sessionStatus).length;

  return (
    <div>
      {/* Header */}
      <div className="rs-dash-header">
        <h2>Seus Canais</h2>
        <span className="rs-dash-counter">Canais {activeCount}/{MAX_ACTIVE}</span>
      </div>

      {/* Action buttons */}
      <div className="rs-dash-actions">
        <button className="rs-btn" onClick={() => setAddModal(true)}>+ Adicionar Canal</button>
        <button className="rs-btn" onClick={() => setShowTitleModal(true)}>✎ Atualizar Título</button>
        {isOnline && (
          <span style={{ fontSize: 13, color: 'var(--green)', alignSelf: 'center' }}>
            ● AO VIVO — {totalConnections} conexões
          </span>
        )}
      </div>

      {/* Toggle all */}
      {/* <div className="rs-toggle-all">
        <span>Alternar todos</span>
        <div className="rs-toggle-all-btns">
          <button className="rs-btn" onClick={() => handleToggleAll(false)}>OFF</button>
          <button className="rs-btn" onClick={() => handleToggleAll(true)}>ON</button>
        </div>
      </div> */}

      {/* Channel list */}
      {!loaded ? (
        <div className="rs-empty">Carregando canais…</div>
      ) : pages.length === 0 ? (
        <div className="rs-empty">Nenhum canal configurado. Adicione um canal para começar.</div>
      ) : (
        pages.filter(d => d.selected).map((dest, i) => (
          <ChannelCard
            key={dest._id || dest.id || i}
            dest={dest}
            title={title}
            isWebcam={isWebcam}
            isScreen={isScreen}
            onToggle={handleToggle}
            onEdit={openInstaEdit}
            onSchedule={openSchedule}
            onRadioChange={handleRadioChange}
          />
        ))
      )}

      {/* Alert notifications */}
      {alertMessages.length > 0 && (
        <div className="rs-alerts">
          <h4><FontAwesomeIcon icon={faBullhorn} /> NOVIDADES</h4>
          <ul className="rs-alert-list">
            {alertMessages.map((n, i) => <li key={i}>{n.message}</li>)}
          </ul>
        </div>
      )}

      {/* ── Update Title Modal ── */}
      {showTitleModal && (
        <div className="rs-modal-overlay" onClick={e => { if (e.target === e.currentTarget) setShowTitleModal(false); }}>
          <div className="rs-modal-box">
            <div className="rs-modal-header">
              <h3>Atualizar Título</h3>
              <button className="rs-modal-close" onClick={() => setShowTitleModal(false)}>✕</button>
            </div>
            <Form ref={c => { titleFormRef.current = c; }} onSubmit={handleUpdateTitle}>
              <div className="rs-form-group">
                <label className="rs-label">Título ({title.length}/100)</label>
                <input className="rs-input" type="text" value={title} maxLength={100}
                  onChange={e => setTitle(e.target.value)} />
              </div>
              <div className="rs-form-group">
                <label className="rs-label">Descrição ({description.length}/5000)</label>
                <textarea className="rs-input" rows={3} value={description} maxLength={5000}
                  onChange={e => setDesc(e.target.value)} style={{ resize: 'vertical' }} />
              </div>
              <div className="rs-form-group">
                <label className="rs-label">Resolução</label>
                <select className="rs-modal-select" value={selectedRes} onChange={e => setSelectedRes(e.target.value)}>
                  {RESOLUTIONS.map(r => <option key={r}>{r}</option>)}
                </select>
              </div>
              <div className="rs-modal-actions">
                <button type="button" className="rs-btn" onClick={() => setShowTitleModal(false)}>Cancelar</button>
                <button type="submit" className="rs-btn">Atualizar</button>
              </div>
            </Form>
          </div>
        </div>
      )}

      {/* ── Add Channel Modal ── */}
      {addModal && (
        <div className="rs-modal-overlay" onClick={e => { if (e.target === e.currentTarget) { setAddModal(false); setSocialSelect(''); } }}>
          <div className="rs-modal-box" style={{ width: 460 }}>
            <div className="rs-modal-header">
              <h3>Adicionar Canal</h3>
              <button className="rs-modal-close" onClick={() => { setAddModal(false); setSocialSelect(''); }}>✕</button>
            </div>
            <p style={{ fontSize: 13, color: 'var(--muted)', margin: '0 0 14px' }}>
              Escolha a plataforma para conectar:
            </p>

            {/* Platform selector */}
            <div className="rs-form-group">
              <label className="rs-label">Plataforma</label>
              <select className="rs-modal-select" value={socialSelect} onChange={e => setSocialSelect(e.target.value)}>
                <option value="">-- Selecionar --</option>
                <option value="Facebook">Facebook</option>
                <option value="YouTube">YouTube</option>
                {/* <option value="Instagram">Instagram</option> */}
                <option value="Custom">Custom RTMP</option>
              </select>
            </div>

            {/* Facebook — OAuth button */}
            {socialSelect === 'Facebook' && (
              <div style={{ marginTop: 12 }}>
                <p style={{ fontSize: 13, color: 'var(--muted)', margin: '0 0 10px' }}>
                  Clique abaixo para autorizar suas páginas do Facebook.
                </p>
                <FacebookLogin
                  appId={FB_CLIENT_ID}
                  fields="name,email,picture"
                  scope="public_profile,email,pages_show_list,pages_read_engagement,pages_manage_posts"
                  callback={handleAddFacebook}
                  render={p => (
                    <button className="rs-btn" style={{ width: '100%', padding: '10px' }} onClick={p.onClick}>
                      🔵 Conectar com Facebook
                    </button>
                  )}
                />
              </div>
            )}

            {/* YouTube — Google OAuth button */}
            {socialSelect === 'YouTube' && (
              <div style={{ marginTop: 12 }}>
                <p style={{ fontSize: 13, color: 'var(--muted)', margin: '0 0 10px' }}>
                  Clique abaixo para autorizar seu canal do YouTube.
                </p>
                <GoogleLogin
                  clientId={GOOGLE_CLIENT_ID}
                  onSuccess={handleAddGoogle}
                  onFailure={() => {}}
                  responseType="code"
                  accessType="offline"
                  render={p => (
                    <button className="rs-btn" style={{ width: '100%', padding: '10px' }} onClick={p.onClick}>
                      🔴 Conectar com YouTube
                    </button>
                  )}
                />
              </div>
            )}

            {/* Instagram — popup window */}
            {socialSelect === 'Instagram' && (
              <div style={{ marginTop: 12 }}>
                <p style={{ fontSize: 13, color: 'var(--muted)', margin: '0 0 10px' }}>
                  Clique abaixo para abrir a janela de login do Instagram.
                </p>
                <button className="rs-btn" style={{ width: '100%', padding: '10px' }} onClick={openInstagramLogin}>
                  📸 Conectar com Instagram
                </button>
              </div>
            )}

            {/* Custom RTMP — inline form */}
            {socialSelect === 'Custom' && (
              <form onSubmit={handleAddCustom} style={{ marginTop: 12 }}>
                <div className="rs-form-group">
                  <label className="rs-label">Tipo de plataforma</label>
                  <select className="rs-modal-select" value={customSite} onChange={e => setCustomSite(e.target.value)}>
                    {['Youtube', 'Facebook', 'Instagram', 'Others'].map(s => <option key={s}>{s}</option>)}
                  </select>
                </div>
                <div className="rs-form-group">
                  <label className="rs-label">Nome do canal</label>
                  <input className="rs-input" value={customName} onChange={e => setCustomName(e.target.value)} placeholder="Ex: Meu Canal" required />
                </div>
                <div className="rs-form-group">
                  <label className="rs-label">RTMP URL</label>
                  <input className="rs-input" value={customRtmp} onChange={e => setCustomRtmp(e.target.value)} placeholder="rtmp://live.example.com/app" required />
                </div>
                <div className="rs-form-group">
                  <label className="rs-label">Stream Key</label>
                  <input className="rs-input" value={customKeyAdd} onChange={e => setCustomKeyAdd(e.target.value)} placeholder="stream-key" required />
                </div>
                {customSite === 'Instagram' && (
                  <div className="rs-form-group">
                    <label className="rs-label">Orientação</label>
                    <select className="rs-modal-select" value={broadcastType} onChange={e => setBroadcastType(e.target.value)}>
                      <option value="normal">Normal (vertical)</option>
                      <option value="paisagem">Paisagem (horizontal)</option>
                      <option value="square">Square</option>
                    </select>
                  </div>
                )}
                <div className="rs-modal-actions">
                  <button type="button" className="rs-btn" onClick={() => { setAddModal(false); setSocialSelect(''); }}>Cancelar</button>
                  <button type="submit" className="rs-btn">Adicionar</button>
                </div>
              </form>
            )}

            {/* Cancel for non-form platforms */}
            {socialSelect !== 'Custom' && (
              <div className="rs-modal-actions" style={{ marginTop: 16 }}>
                <button className="rs-btn" onClick={() => { setAddModal(false); setSocialSelect(''); }}>Cancelar</button>
              </div>
            )}
          </div>
        </div>
      )}

      {/* ── Schedule Modal ── */}
      {schedModal && (
        <div className="rs-modal-overlay" onClick={e => { if (e.target === e.currentTarget) setSchedModal(false); }}>
          <div className="rs-modal-box" style={{ width: 480 }}>
            <div className="rs-modal-header">
              <h3>Agendar Transmissão</h3>
              <button className="rs-modal-close" onClick={() => setSchedModal(false)}>✕</button>
            </div>
            <form onSubmit={handleAddSchedule}>
              <div className="rs-form-group">
                <label className="rs-label">Título</label>
                <input className="rs-input" value={title} onChange={e => setTitle(e.target.value)} />
              </div>
              <div className="rs-form-group">
                <label className="rs-label">Descrição</label>
                <textarea className="rs-input" rows={3} value={description} onChange={e => setDesc(e.target.value)} style={{ resize: 'vertical' }} />
              </div>
              <div className="rs-form-group">
                <label className="rs-label">Repetir</label>
                <select className="rs-modal-select" value={schedType} onChange={e => setSchedType(e.target.value)}>
                  {SCHED_TYPES.map(t => <option key={t}>{t}</option>)}
                </select>
              </div>
              {schedType === 'Semanalmente' && (
                <div className="rs-form-group">
                  <MultiSelect options={WEEKLY} value={selectedDays} onChange={setSelectedDays} multi placeholder="Selecionar dias" />
                </div>
              )}
              {schedType === 'Mensalmente' && (
                <div className="rs-form-group">
                  <MultiSelect options={DATES} value={selectedDates} onChange={setSelectedDates} multi placeholder="Selecionar datas" />
                </div>
              )}
              <div className="rs-form-group" style={{ display: 'flex', gap: 12 }}>
                <div style={{ flex: 1 }}>
                  <label className="rs-label">Hora início</label>
                  <input className="rs-input" type="time" value={startTime} onChange={e => setStartTime(e.target.value)} />
                </div>
                <div style={{ flex: 1 }}>
                  <label className="rs-label">Hora fim</label>
                  <input className="rs-input" type="time" value={endTime} onChange={e => setEndTime(e.target.value)} />
                </div>
              </div>
              <div className="rs-modal-actions">
                <button type="button" className="rs-btn" onClick={() => setSchedModal(false)}>Cancelar</button>
                <button type="submit" className="rs-btn">Adicionar</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* ── Instagram Key Modal ── */}
      {instaModal && (
        <div className="rs-modal-overlay" onClick={e => { if (e.target === e.currentTarget) setInstaModal(false); }}>
          <div className="rs-modal-box">
            <div className="rs-modal-header">
              <h3>Editar Stream Key</h3>
              <button className="rs-modal-close" onClick={() => setInstaModal(false)}>✕</button>
            </div>
            <form onSubmit={handleInstaUpdate}>
              <div className="rs-form-group">
                <label className="rs-label">Plataforma</label>
                <input className="rs-input" disabled value={instaData.platformType || ''} />
              </div>
              <div className="rs-form-group">
                <label className="rs-label">Nome</label>
                <input className="rs-input" disabled value={instaData.name || ''} />
              </div>
              <div className="rs-form-group">
                <label className="rs-label">RTMP URL</label>
                <input className="rs-input" disabled value={instaData.customRtmp || ''} />
              </div>
              <div className="rs-form-group">
                <label className="rs-label">Stream Key</label>
                <input className="rs-input" value={customKey} onChange={e => setCustomKey(e.target.value)} />
              </div>
              <div className="rs-modal-actions">
                <button type="button" className="rs-btn" onClick={() => setInstaModal(false)}>Cancelar</button>
                <button type="submit" className="rs-btn">Atualizar</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* ── OTP Modal ── */}
      {otpModal && (
        <div className="rs-modal-overlay">
          <div className="rs-modal-box">
            <div className="rs-modal-header">
              <h3>Verificação em 2 Etapas</h3>
              <button className="rs-modal-close" onClick={() => setOtpModal(false)}>✕</button>
            </div>
            <form onSubmit={handleOtpSubmit}>
              <div className="rs-form-group">
                <label className="rs-label">Digite o OTP de 6 dígitos</label>
                <input className="rs-input" type="number" value={otpValue}
                  onChange={e => setOtpValue(e.target.value)} placeholder="000000" maxLength={6} />
              </div>
              <div className="rs-modal-actions">
                <button type="button" className="rs-btn" onClick={() => setOtpModal(false)}>Cancelar</button>
                <button type="submit" className="rs-btn">Enviar</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/DashboardPage/Dashboard/DashboardDefault/DashboardDefault.js